import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** サービス
 * このenumはpp_bos_authのmanaged_policyと連携しているので、
 * 追加・削除する場合は認証Tに連絡してください。
 */
enum ServiceKey {
  /** 繰越 */
  carryover = 'carryover',
  /** 物件管理設定 */
  articleManagementSettings = 'article-management-settings',
  /** 会計方針(固定資産管理) */
  accountingPolicy = 'accounting-policy',
  /** 利子率 */
  interestRateSettings = 'interest-rate-settings',
  /** マスタ設定 */
  mstSettings = 'mst-settings',
  /** ジョブ監視(会社) */
  jobWatch = 'job-watch',
  /** リース開始登録 */
  leaseContractStart = 'lease-contract-start',
  /** リース契約新規支払展開 */
  leaseContractDeployNewPayment = 'lease-contract-deploy-new-payment',
  /** リース契約情報変更 */
  leaseContractChange = 'lease-contract-change',
  /** リース物件情報変更 */
  leaseArticleChange = 'lease-article-change',
  /** リース契約中途解約 */
  leaseContractCancelBeforeMaturity = 'lease-contract-cancel-before-maturity',
  /** 再リース及び契約満了 */
  reLeaseAndContractExpired = 're-lease-and-contract-expired',
  /** リース登録取消 */
  leaseCancel = 'lease-cancel',
  /** リース契約管理照会 */
  leaseContractInquire = 'lease-contract-inquire',
  /** リース契約管理帳票 */
  leaseContractLedger = 'lease-contract-ledger',
  /** 先行登録管理(固定資産) */
  // fixedAssetEarlyRegistration = 'fixed-asset-early-registration',
  /** 先行登録管理(リース契約) */
  // leaseContractEarlyRegistration = 'lease-contract-early-registration',
  /** リース会社マスタ */
  leaseCompanyMst = 'lease-company-mst',
  /** 種類マスタ */
  categoryMst = 'category-mst',
  /** 分類マスタ */
  subCategoryMst = 'sub-category-mst',
  /** セグメントマスタ01 */
  segmentMst01 = 'segment-mst01',
  /** セグメントマスタ02 */
  segmentMst02 = 'segment-mst02',
  /** セグメントマスタ03 */
  segmentMst03 = 'segment-mst03',
  /** セグメントマスタ04 */
  segmentMst04 = 'segment-mst04',
  /** セグメントマスタ05 */
  segmentMst05 = 'segment-mst05',
  /** 取引先マスタ */
  businessConnectionMst = 'business-connection-mst',
  /** 設置場所マスタ */
  locationMst = 'location-mst',
  /** 固定資産減損損失計上 */
  fixedAssetImpairmentLossEntry = 'fixed-asset-impairment-loss-entry',
  /** 固定資産増減取消 */
  fixedAssetCancel = 'fixed-asset-cancel',
  /** 固定資産照会 */
  // fixedAssetInquiry = 'fixed-asset-inquiry',
  /** 固定資産帳票 */
  fixedAssetLedger = 'fixed-asset-ledger',
  /**  リース債務見積変更 */
  leaseLiabilityEstimateChange = 'lease-liability-estimate-change',
  /** リース債務帳票 */
  leaseLiabilityLedger = 'lease-liability-ledger',
  /** リース残高移行 */
  leaseMigrateBalance = 'lease-migrate-balance',
  /** 運用制御 */
  operationControl = 'operation-control',
}

const nameConfig = {
  carryover: new Map([
    [Locale.ja, '繰越'],
    [Locale.en, 'Carryover'],
  ]),
  articleManagementSettings: new Map([
    [Locale.ja, '物件管理設定'],
    [Locale.en, 'ArticleManagementSettings'],
  ]),
  accountingPolicy: new Map([
    [Locale.ja, '会計方針(固定資産管理)'],
    [Locale.en, 'AccountingPolicy'],
  ]),
  interestRateSettings: new Map([
    [Locale.ja, '利子率'],
    [Locale.en, 'InterestRateSetting'],
  ]),
  mstSettings: new Map([
    [Locale.ja, 'マスタ設定'],
    [Locale.en, 'MstSettings'],
  ]),
  jobWatch: new Map([
    [Locale.ja, 'ジョブ監視(会社)'],
    [Locale.en, 'JobWatch'],
  ]),
  leaseContractStart: new Map([
    [Locale.ja, 'リース開始登録'],
    [Locale.en, 'LeaseContractStart'],
  ]),
  leaseContractDeployNewPayment: new Map([
    [Locale.ja, 'リース契約新規支払展開'],
    [Locale.en, 'LeaseContractDeployNewPayment'],
  ]),
  leaseContractChange: new Map([
    [Locale.ja, 'リース契約情報変更'],
    [Locale.en, 'LeaseContractInfoChange'],
  ]),
  leaseArticleChange: new Map([
    [Locale.ja, 'リース物件情報変更'],
    [Locale.en, 'LeaseArticleInfoChange'],
  ]),
  leaseContractCancelBeforeMaturity: new Map([
    [Locale.ja, 'リース契約中途解約'],
    [Locale.en, 'LeaseContractCancelBeforeMaturity'],
  ]),
  reLeaseAndContractExpired: new Map([
    [Locale.ja, '再リース及び契約満了'],
    [Locale.en, 'ReLeaseAndContractExpired'],
  ]),
  leaseCancel: new Map([
    [Locale.ja, 'リース登録取消'],
    [Locale.en, 'LeaseCancelRegistration'],
  ]),
  leaseContractInquire: new Map([
    [Locale.ja, 'リース契約管理照会'],
    [Locale.en, 'LeaseContractInquire'],
  ]),
  leaseContractLedger: new Map([
    [Locale.ja, 'リース契約管理帳票'],
    [Locale.en, 'LeaseContractLedger'],
  ]),
  fixedAssetEarlyRegistration: new Map([
    [Locale.ja, '先行登録管理(固定資産)'],
    [Locale.en, 'FixedAssetEarlyRegistration'],
  ]),
  leaseContractEarlyRegistration: new Map([
    [Locale.ja, '先行登録管理(リース契約)'],
    [Locale.en, 'LeaseContractEarlyRegistration'],
  ]),
  leaseCompanyMst: new Map([
    [Locale.ja, 'リース会社マスタ'],
    [Locale.en, 'LeaseCompanyMst'],
  ]),
  categoryMst: new Map([
    [Locale.ja, '種類マスタ'],
    [Locale.en, 'CategoryMst'],
  ]),
  subCategoryMst: new Map([
    [Locale.ja, '分類マスタ'],
    [Locale.en, 'SubCategoryMst'],
  ]),
  segmentMst01: new Map([
    [Locale.ja, 'セグメントマスタ01'],
    [Locale.en, 'SegmentMst01'],
  ]),
  segmentMst02: new Map([
    [Locale.ja, 'セグメントマスタ02'],
    [Locale.en, 'SegmentMst02'],
  ]),
  segmentMst03: new Map([
    [Locale.ja, 'セグメントマスタ03'],
    [Locale.en, 'SegmentMst03'],
  ]),
  segmentMst04: new Map([
    [Locale.ja, 'セグメントマスタ04'],
    [Locale.en, 'SegmentMst04'],
  ]),
  segmentMst05: new Map([
    [Locale.ja, 'セグメントマスタ05'],
    [Locale.en, 'SegmentMst05'],
  ]),
  businessConnectionMst: new Map([
    [Locale.ja, '取引先マスタ'],
    [Locale.en, 'BusinessConnectionMst'],
  ]),
  locationMst: new Map([
    [Locale.ja, '設置場所マスタ'],
    [Locale.en, 'LocationMst'],
  ]),
  fixedAssetImpairmentLossEntry: new Map([
    [Locale.ja, '固定資産減損損失計上'],
    [Locale.en, 'FixedAssetImpairmentLossEntry'],
  ]),
  fixedAssetCancel: new Map([
    [Locale.ja, '固定資産増減取消'],
    [Locale.en, 'FixedAssetCancelIncreDecre'],
  ]),
  fixedAssetInquiry: new Map([
    [Locale.ja, '固定資産照会'],
    [Locale.en, 'FixedAssetInquiry'],
  ]),
  fixedAssetLedger: new Map([
    [Locale.ja, '固定資産帳票'],
    [Locale.en, 'FixedAssetLedger'],
  ]),
  leaseLiabilityEstimateChange: new Map([
    [Locale.ja, 'リース債務見積変更'],
    [Locale.en, 'LeaseLiabilityEstimateChange'],
  ]),
  leaseLiabilityLedger: new Map([
    [Locale.ja, 'リース債務帳票'],
    [Locale.en, 'LeaseLiabilityLedger'],
  ]),
  leaseMigrateBalance: new Map([
    [Locale.ja, 'リース残高移行'],
    [Locale.en, 'LeaseMigrateBalance'],
  ]),
  operationControl: new Map([
    [Locale.ja, '運用制御'],
    [Locale.en, 'OperationControl'],
  ]),
};

const toEnum = rawValueToEnum(ServiceKey, ServiceKey.carryover);
const toDisplay = enumToName(ServiceKey, nameConfig);
const toDisplayWithPrefix = enumToName(ServiceKey, nameConfig, { prefix: true });

export const serviceKey = {
  enum: ServiceKey,
  nameConfig,
  toEnum,
  toDisplay,
  toDisplayWithPrefix,
};
export type { ServiceKey };
